/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction, replaceWithSerializableTypeIfNeeded } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { AnswerInterviewSimulationQuestionRequestDto } from '../models';
// @ts-ignore
import type { CreateInterviewSimulationResponseDto } from '../models';
// @ts-ignore
import type { GetInterviewSimulationDetailsResponseDto } from '../models';
// @ts-ignore
import type { GetInterviewSimulationStatusResponseDto } from '../models';
// @ts-ignore
import type { GetInterviewSimulationsResponseDto } from '../models';
/**
 * InterviewSimulationsRestApi - axios parameter creator
 */
export const InterviewSimulationsRestApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Answer a question of an interview simulation for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {number} interviewSimulationId 
         * @param {number} questionId 
         * @param {AnswerInterviewSimulationQuestionRequestDto} answerInterviewSimulationQuestionRequestDto Question answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerCandidateApplicationInterviewSimulationQuestion: async (processId: string, candidateApplicationId: string, interviewSimulationId: number, questionId: number, answerInterviewSimulationQuestionRequestDto: AnswerInterviewSimulationQuestionRequestDto, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('answerCandidateApplicationInterviewSimulationQuestion', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('answerCandidateApplicationInterviewSimulationQuestion', 'candidateApplicationId', candidateApplicationId)
            // verify required parameter 'interviewSimulationId' is not null or undefined
            assertParamExists('answerCandidateApplicationInterviewSimulationQuestion', 'interviewSimulationId', interviewSimulationId)
            // verify required parameter 'questionId' is not null or undefined
            assertParamExists('answerCandidateApplicationInterviewSimulationQuestion', 'questionId', questionId)
            // verify required parameter 'answerInterviewSimulationQuestionRequestDto' is not null or undefined
            assertParamExists('answerCandidateApplicationInterviewSimulationQuestion', 'answerInterviewSimulationQuestionRequestDto', answerInterviewSimulationQuestionRequestDto)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/interview-simulations/{interviewSimulationId}/questions/{questionId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)))
                .replace('{interviewSimulationId}', encodeURIComponent(String(interviewSimulationId)))
                .replace('{questionId}', encodeURIComponent(String(questionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(answerInterviewSimulationQuestionRequestDto, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create a new interview simulation for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCandidateApplicationInterviewSimulation: async (processId: string, candidateApplicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('createCandidateApplicationInterviewSimulation', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('createCandidateApplicationInterviewSimulation', 'candidateApplicationId', candidateApplicationId)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/interview-simulations`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get details of an interview simulation for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {number} interviewSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationInterviewSimulationDetails: async (processId: string, candidateApplicationId: string, interviewSimulationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getCandidateApplicationInterviewSimulationDetails', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('getCandidateApplicationInterviewSimulationDetails', 'candidateApplicationId', candidateApplicationId)
            // verify required parameter 'interviewSimulationId' is not null or undefined
            assertParamExists('getCandidateApplicationInterviewSimulationDetails', 'interviewSimulationId', interviewSimulationId)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/interview-simulations/{interviewSimulationId}`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)))
                .replace('{interviewSimulationId}', encodeURIComponent(String(interviewSimulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get status of an interview simulation for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {number} interviewSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationInterviewSimulationStatus: async (processId: string, candidateApplicationId: string, interviewSimulationId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getCandidateApplicationInterviewSimulationStatus', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('getCandidateApplicationInterviewSimulationStatus', 'candidateApplicationId', candidateApplicationId)
            // verify required parameter 'interviewSimulationId' is not null or undefined
            assertParamExists('getCandidateApplicationInterviewSimulationStatus', 'interviewSimulationId', interviewSimulationId)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/interview-simulations/{interviewSimulationId}/status`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)))
                .replace('{interviewSimulationId}', encodeURIComponent(String(interviewSimulationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get a list of interview simulations for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationInterviewSimulations: async (processId: string, candidateApplicationId: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'processId' is not null or undefined
            assertParamExists('getCandidateApplicationInterviewSimulations', 'processId', processId)
            // verify required parameter 'candidateApplicationId' is not null or undefined
            assertParamExists('getCandidateApplicationInterviewSimulations', 'candidateApplicationId', candidateApplicationId)
            const localVarPath = `/api/v1/processes/{processId}/candidate-applications/{candidateApplicationId}/interview-simulations`
                .replace('{processId}', encodeURIComponent(String(processId)))
                .replace('{candidateApplicationId}', encodeURIComponent(String(candidateApplicationId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            localVarHeaderParameter['Accept'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * InterviewSimulationsRestApi - functional programming interface
 */
export const InterviewSimulationsRestApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = InterviewSimulationsRestApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Answer a question of an interview simulation for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {number} interviewSimulationId 
         * @param {number} questionId 
         * @param {AnswerInterviewSimulationQuestionRequestDto} answerInterviewSimulationQuestionRequestDto Question answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async answerCandidateApplicationInterviewSimulationQuestion(processId: string, candidateApplicationId: string, interviewSimulationId: number, questionId: number, answerInterviewSimulationQuestionRequestDto: AnswerInterviewSimulationQuestionRequestDto, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.answerCandidateApplicationInterviewSimulationQuestion(processId, candidateApplicationId, interviewSimulationId, questionId, answerInterviewSimulationQuestionRequestDto, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSimulationsRestApi.answerCandidateApplicationInterviewSimulationQuestion']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create a new interview simulation for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createCandidateApplicationInterviewSimulation(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CreateInterviewSimulationResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createCandidateApplicationInterviewSimulation(processId, candidateApplicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSimulationsRestApi.createCandidateApplicationInterviewSimulation']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get details of an interview simulation for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {number} interviewSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateApplicationInterviewSimulationDetails(processId: string, candidateApplicationId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInterviewSimulationDetailsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateApplicationInterviewSimulationDetails(processId, candidateApplicationId, interviewSimulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSimulationsRestApi.getCandidateApplicationInterviewSimulationDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get status of an interview simulation for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {number} interviewSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateApplicationInterviewSimulationStatus(processId: string, candidateApplicationId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInterviewSimulationStatusResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateApplicationInterviewSimulationStatus(processId, candidateApplicationId, interviewSimulationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSimulationsRestApi.getCandidateApplicationInterviewSimulationStatus']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get a list of interview simulations for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCandidateApplicationInterviewSimulations(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<GetInterviewSimulationsResponseDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCandidateApplicationInterviewSimulations(processId, candidateApplicationId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['InterviewSimulationsRestApi.getCandidateApplicationInterviewSimulations']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * InterviewSimulationsRestApi - factory interface
 */
export const InterviewSimulationsRestApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = InterviewSimulationsRestApiFp(configuration)
    return {
        /**
         * 
         * @summary Answer a question of an interview simulation for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {number} interviewSimulationId 
         * @param {number} questionId 
         * @param {AnswerInterviewSimulationQuestionRequestDto} answerInterviewSimulationQuestionRequestDto Question answer
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        answerCandidateApplicationInterviewSimulationQuestion(processId: string, candidateApplicationId: string, interviewSimulationId: number, questionId: number, answerInterviewSimulationQuestionRequestDto: AnswerInterviewSimulationQuestionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.answerCandidateApplicationInterviewSimulationQuestion(processId, candidateApplicationId, interviewSimulationId, questionId, answerInterviewSimulationQuestionRequestDto, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create a new interview simulation for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createCandidateApplicationInterviewSimulation(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<CreateInterviewSimulationResponseDto> {
            return localVarFp.createCandidateApplicationInterviewSimulation(processId, candidateApplicationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get details of an interview simulation for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {number} interviewSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationInterviewSimulationDetails(processId: string, candidateApplicationId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewSimulationDetailsResponseDto> {
            return localVarFp.getCandidateApplicationInterviewSimulationDetails(processId, candidateApplicationId, interviewSimulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get status of an interview simulation for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {number} interviewSimulationId 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationInterviewSimulationStatus(processId: string, candidateApplicationId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewSimulationStatusResponseDto> {
            return localVarFp.getCandidateApplicationInterviewSimulationStatus(processId, candidateApplicationId, interviewSimulationId, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get a list of interview simulations for a candidate application
         * @param {string} processId 
         * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCandidateApplicationInterviewSimulations(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewSimulationsResponseDto> {
            return localVarFp.getCandidateApplicationInterviewSimulations(processId, candidateApplicationId, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * InterviewSimulationsRestApi - interface
 */
export interface InterviewSimulationsRestApiInterface {
    /**
     * 
     * @summary Answer a question of an interview simulation for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {number} interviewSimulationId 
     * @param {number} questionId 
     * @param {AnswerInterviewSimulationQuestionRequestDto} answerInterviewSimulationQuestionRequestDto Question answer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    answerCandidateApplicationInterviewSimulationQuestion(processId: string, candidateApplicationId: string, interviewSimulationId: number, questionId: number, answerInterviewSimulationQuestionRequestDto: AnswerInterviewSimulationQuestionRequestDto, options?: RawAxiosRequestConfig): AxiosPromise<void>;

    /**
     * 
     * @summary Create a new interview simulation for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    createCandidateApplicationInterviewSimulation(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<CreateInterviewSimulationResponseDto>;

    /**
     * 
     * @summary Get details of an interview simulation for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {number} interviewSimulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateApplicationInterviewSimulationDetails(processId: string, candidateApplicationId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewSimulationDetailsResponseDto>;

    /**
     * 
     * @summary Get status of an interview simulation for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {number} interviewSimulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateApplicationInterviewSimulationStatus(processId: string, candidateApplicationId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewSimulationStatusResponseDto>;

    /**
     * 
     * @summary Get a list of interview simulations for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getCandidateApplicationInterviewSimulations(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig): AxiosPromise<GetInterviewSimulationsResponseDto>;

}

/**
 * InterviewSimulationsRestApi - object-oriented interface
 */
export class InterviewSimulationsRestApi extends BaseAPI implements InterviewSimulationsRestApiInterface {
    /**
     * 
     * @summary Answer a question of an interview simulation for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {number} interviewSimulationId 
     * @param {number} questionId 
     * @param {AnswerInterviewSimulationQuestionRequestDto} answerInterviewSimulationQuestionRequestDto Question answer
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public answerCandidateApplicationInterviewSimulationQuestion(processId: string, candidateApplicationId: string, interviewSimulationId: number, questionId: number, answerInterviewSimulationQuestionRequestDto: AnswerInterviewSimulationQuestionRequestDto, options?: RawAxiosRequestConfig) {
        return InterviewSimulationsRestApiFp(this.configuration).answerCandidateApplicationInterviewSimulationQuestion(processId, candidateApplicationId, interviewSimulationId, questionId, answerInterviewSimulationQuestionRequestDto, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create a new interview simulation for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public createCandidateApplicationInterviewSimulation(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig) {
        return InterviewSimulationsRestApiFp(this.configuration).createCandidateApplicationInterviewSimulation(processId, candidateApplicationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get details of an interview simulation for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {number} interviewSimulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCandidateApplicationInterviewSimulationDetails(processId: string, candidateApplicationId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig) {
        return InterviewSimulationsRestApiFp(this.configuration).getCandidateApplicationInterviewSimulationDetails(processId, candidateApplicationId, interviewSimulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get status of an interview simulation for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {number} interviewSimulationId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCandidateApplicationInterviewSimulationStatus(processId: string, candidateApplicationId: string, interviewSimulationId: number, options?: RawAxiosRequestConfig) {
        return InterviewSimulationsRestApiFp(this.configuration).getCandidateApplicationInterviewSimulationStatus(processId, candidateApplicationId, interviewSimulationId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get a list of interview simulations for a candidate application
     * @param {string} processId 
     * @param {string} candidateApplicationId Application-first candidate ID used by client flows.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    public getCandidateApplicationInterviewSimulations(processId: string, candidateApplicationId: string, options?: RawAxiosRequestConfig) {
        return InterviewSimulationsRestApiFp(this.configuration).getCandidateApplicationInterviewSimulations(processId, candidateApplicationId, options).then((request) => request(this.axios, this.basePath));
    }
}

